import { render, staticRenderFns } from "./NewsPagination.vue?vue&type=template&id=44589816&scoped=true&"
import script from "./NewsPagination.vue?vue&type=script&lang=js&"
export * from "./NewsPagination.vue?vue&type=script&lang=js&"
import style0 from "./NewsPagination.vue?vue&type=style&index=0&id=44589816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44589816",
  null
  
)

component.options.__file = "NewsPagination.vue"
export default component.exports